var ApiErrorReason;
(function (ApiErrorReason) {
    ApiErrorReason["SESSION_SNAPSHOTS_LIMIT_REACHED"] = "SESSION_SNAPSHOTS_LIMIT_REACHED";
    ApiErrorReason["SESSION_SCREENSHOTS_LIMIT_REACHED"] = "SESSION_SCREENSHOTS_LIMIT_REACHED";
    ApiErrorReason["SESSION_EXPIRED"] = "SESSION_EXPIRED";
    ApiErrorReason["SESSION_LIMIT_REACHED"] = "SESSION_LIMIT_REACHED";
})(ApiErrorReason || (ApiErrorReason = {}));
export default ApiErrorReason;
